import { Typography, Flex, Input } from "antd"
import ConfigInput from "./ConfigInput"
import { useTranslation } from 'react-i18next';
const { Title } = Typography

const Configuration = () => {
    const { t } = useTranslation();


    return (
        <div className="page-wrapper">
            <Title className="text-h2 text-weight-600" style={{ marginTop: "0", marginBottom: "1.25rem" }}>{t('Work Configuration')}</Title>
            <div className="config-table">
                <Flex vertical>
                    <Flex className="config-row">
                        <div className="config-header table-cell"></div>
                        <div className="config-header table-cell">{t('Work Year')}</div>
                        <div className="config-header table-cell">{t('Work Semi Annual')}</div>
                        <div className="config-header table-cell">{t('Work Quarter')}</div>
                        <div className="config-header table-cell">{t('Work Month')}</div>
                        <div className="config-header table-cell">{t('Work Week')}</div>
                        <div className="config-header table-cell">{t('Work Day')}</div>
                        <div className="config-header table-cell">{t('Work Hour')}</div>
                    </Flex>
                    <Flex className="data-row">
                        <div className="config-cell table-cell">{t('Work Year')}</div>
                        <div className="config-cell table-cell default-value-cell">1</div>
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                    </Flex>
                    <Flex className="data-row">
                        <div className="config-cell table-cell">{t('Work Semi Annual')}</div>
                        <ConfigInput />
                        <div className="config-cell table-cell default-value-cell">1</div>
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                    </Flex><Flex className="data-row">
                        <div className="config-cell table-cell">{t('Work Quarter')}</div>
                        <ConfigInput />
                        <ConfigInput />
                        <div className="config-cell table-cell default-value-cell">1</div>
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                    </Flex>
                    <Flex className="data-row">
                        <div className="config-cell table-cell">{t('Work Month')}</div>
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <div className="config-cell table-cell default-value-cell">1</div>
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                    </Flex>
                    <Flex className="data-row">
                        <div className="config-cell table-cell">{t('Work Week')}</div>
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <div className="config-cell table-cell default-value-cell">1</div>
                        <ConfigInput />
                        <ConfigInput />
                    </Flex><Flex className="data-row">
                        <div className="config-cell table-cell">{t('Work Day')}</div>
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <div className="config-cell table-cell default-value-cell">1</div>
                        <ConfigInput />
                    </Flex><Flex className="data-row">
                        <div className="config-cell table-cell">{t('Work Hour')}</div>
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <ConfigInput />
                        <div className="config-cell table-cell default-value-cell">1</div>
                    </Flex>
                </Flex>
            </div>


        </div>
    )
}

export default Configuration